import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-slate" data-id="element-106" data-mp="1o2vhap4uen6k">
      <div className="mx-auto max-w-5xl px-5 sm:px-8 py-20" data-id="element-107" data-mp="223em7ne0hd4i">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center gap-6 text-center md:flex-row md:text-left" data-id="element-108" data-mp="222wiy6sxlyn3">
          <span className="flex h-20 w-20 shrink-0 items-center justify-center rounded-2xl bg-magenta text-white shadow-lg shadow-magenta/30" data-id="element-109" data-mp="1j6die5w71j25">
            <ShieldCheckIcon className="h-10 w-10" strokeWidth={1.8} data-id="element-110" data-mp="qn7utc3xytkp" />
          </span>
          <div data-id="element-111" data-mp="lpy8i5bumy13">
            <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-white" data-id="element-112" data-mp="lo4wsbmdpnm8">
              100% Satisfaction Guarantee
            </h2>
            <p className="mt-3 max-w-2xl text-white/75 leading-relaxed" data-id="element-113" data-mp="oxoz5u2peqwo">
              If you are not completely satisfied, we will return within 24
              hours to make it right. Your peace of mind is our priority.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}